import { useFragment } from '@apollo/client';
import { DocumentMetadataPropertyUiWidgetHintEnum } from 'shared/domains/apollo/generated/types';
import { AddMetadataBooleanSelection } from './AddMetadataBooleanSelection';
import { AddMetadataDateSelection } from './AddMetadataDateSelection';
import { AddMetadataDistinctValueSelection } from './AddMetadataDistinctValueSelection';
import { AddMetadataMultiLineTextSelection } from './AddMetadataMultilineTextSelection';
import { AddMetadataNumberSelection } from './AddMetadataNumberSelection';
import { AddMetadataRenderItemFragmentDoc } from './AddMetadataRenderItem.gql';
import { AddMetadataSelectSelection } from './AddMetadataSelectSelection';
import { AddMetadataSimpleTextSelection } from './AddMetadataSimpleTextSelection';
export function AddMetadataRenderItem(props) {
    const { from } = props;
    const { data, complete } = useFragment({
        from,
        fragment: AddMetadataRenderItemFragmentDoc,
        fragmentName: 'AddMetadataRenderItem',
    });
    if (!complete) {
        return null;
    }
    switch (data.uiWidgetHint) {
        case DocumentMetadataPropertyUiWidgetHintEnum.Select:
            return <AddMetadataSelectSelection from={data}/>;
        case DocumentMetadataPropertyUiWidgetHintEnum.SelectWithInput:
            return <AddMetadataDistinctValueSelection from={data}/>;
        case DocumentMetadataPropertyUiWidgetHintEnum.DatePicker:
        case DocumentMetadataPropertyUiWidgetHintEnum.DateTimePicker:
            return <AddMetadataDateSelection from={data}/>;
        case DocumentMetadataPropertyUiWidgetHintEnum.InputNumber:
            return <AddMetadataNumberSelection from={data}/>;
        case DocumentMetadataPropertyUiWidgetHintEnum.InputText:
            return <AddMetadataSimpleTextSelection from={data}/>;
        case DocumentMetadataPropertyUiWidgetHintEnum.TextArea:
            return <AddMetadataMultiLineTextSelection from={data}/>;
        case DocumentMetadataPropertyUiWidgetHintEnum.Switch:
            return <AddMetadataBooleanSelection from={data}/>;
        default: {
            const exhaustive = data.uiWidgetHint;
            return exhaustive;
        }
    }
}
